export default function appReducer(state, action) {
  switch (action.type) {
    case 'GET_PROVEEDORES':
      return {
        ...state,
        proveedores: action.payload
      };
    case 'GET_PRESTADOR_SESSION':
      return {
        ...state,
        prestadorSesion: action.payload
      };
    case 'GET_CONSULTORIOS':
      return {
        ...state,
        consultorios: action.payload
      };
    case 'GET_OSDE':
      return {
        ...state,
        prestadoresOsde: action.payload
      };

    case 'GET_EXTERNO':
      return {
        ...state,
        prestadorExterno: action.payload
      };

    case 'GET_SOLICITUDES_PREVIAS':
      return {
        ...state,
        solicitudesPrestador: [...action.payload]
      };
    case 'STORE_SOLICITUD':
      return {
        ...state,
        solicitudesContrato: [...state.solicitudesContrato, action.payload]
      };
    case 'DELETE_SOLICITUD':
      return {
        ...state,
        solicitudesPrestador: [...action.payload]
      };
    case 'ANULAR_SOLICITUD':
      return {
        ...state,
        solicitudesContrato: action.payload
      };
    case 'GET_SOLICITUD_DETAIL':
      return {
        ...state,
        solicitudDetail: action.payload
      };

    case 'GET_CONSULTORIO_DETAIL':
      return {
        ...state,
        consultorioDetail: action.payload
      };
    case 'ERROR_AUTH':
      return {
        ...state,
        errorAuthPrestador: action.payload
      };
    case 'GET_CONTRATOS_WITH_IC':
      return {
        ...state,
        contratos: action.payload
      };
    case 'GET_CONSULTORIOS_WITH_CONTRATO':
      return {
        ...state,
        consultoriosContrato: action.payload
      };
    case 'GET_SOLICITUDES_WITH_CONTRATO':
      return {
        ...state,
        solicitudesContrato: action.payload
      };
    case 'GET_MOTIVOS_RECHAZO':
      return {
        ...state,
        motivosRechazo: action.payload
      };
    case 'GET_IC_WITH_CONTRATO':
      return {
        ...state,
        icWithContrato: action.payload
      };
      case 'POST_REGISTRAR_ACCESO':
      return {
        ...state,
        registrarAcceso: action.payload
      };
    default:
      return state;
  }
}
